import { render, staticRenderFns } from "./ExpedientesSection.vue?vue&type=template&id=860c9bce&scoped=true"
import script from "./ExpedientesSection.vue?vue&type=script&lang=js"
export * from "./ExpedientesSection.vue?vue&type=script&lang=js"
import style0 from "./ExpedientesSection.vue?vue&type=style&index=0&id=860c9bce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860c9bce",
  null
  
)

export default component.exports